/** Correo canónico de soporte / feedback Vuelto (app, web y tiendas). */
export const SUPPORT_EMAIL = 'soporte@vuelto.ar' as const;

/** WhatsApp soporte y ventas (mismo número). Formato wa.me sin + ni espacios. */
export const SUPPORT_WHATSAPP_E164 = '5491176196898' as const;

export const SUPPORT_WHATSAPP_DISPLAY = '+54 9 11 7619-6898' as const;

export function buildWhatsAppUrl(message: string): string {
  return `https://wa.me/${SUPPORT_WHATSAPP_E164}?text=${encodeURIComponent(message)}`;
}

/** Mensaje prellenado — plan personalizado (landing, ventas). */
export const SALES_CUSTOM_PLAN_WHATSAPP_MESSAGE =
  'Hola, quiero consultar por un plan a medida de Vuelto para mi negocio.';

/** Mensaje prellenado — soporte general. */
export const SUPPORT_WHATSAPP_MESSAGE = 'Hola, necesito ayuda con Vuelto.';

/** Mensaje prellenado — no puede entrar (login / enlace recovery). */
export const LOGIN_ACCESS_HELP_WHATSAPP_MESSAGE =
  'Hola, no puedo entrar a mi cuenta de Vuelto. Necesito ayuda urgente.';

/** Mensaje prellenado — consulta general tras escanear tarjeta (`/hola`). */
export const VISITA_CONSULTA_WHATSAPP_MESSAGE =
  'Hola Matías, te escaneé la tarjeta. Tengo una consulta.';

/** @deprecated Usar {@link VISITA_CONSULTA_WHATSAPP_MESSAGE} o {@link buildVisitaDemoWhatsAppMessage}. */
export const VISITA_WHATSAPP_MESSAGE = VISITA_CONSULTA_WHATSAPP_MESSAGE;

/** Mensaje prellenado — pedir demo con datos del local (`/hola`). */
export function buildVisitaDemoWhatsAppMessage(rubro: string): string {
  return [
    'Hola Matías, te escaneé la tarjeta.',
    '',
    'Quiero una demo con mis datos:',
    '• Local: ',
    `• Rubro: ${rubro}`,
    '• Barrio: ',
    '• Mi WhatsApp: ',
  ].join('\n');
}
